import employees from './components/employee/reducer'
import employeeTypes from './components/employee_type/reducer'

const employee = { employees, employeeTypes }

export {
  employee
}